import { jsx as _jsx } from "react/jsx-runtime";
const SvgLolCreep = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 9,
	viewBox: "0 0 7 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.72803 4.65436L4.20941 0.28256C3.99422 -0.0906683 3.55523 -0.0948573 3.33487 0.274177L0.723286 4.66485C0.558018 4.94162 0.58212 5.33372 0.778376 5.57485L3.38996 8.8039C3.60515 9.07019 3.94774 9.0639 4.15777 8.79342L6.67639 5.54759C6.86404 5.30646 6.88641 4.92694 6.72803 4.65436ZM5.34563 4.6963C5.33875 4.72146 5.32841 4.74662 5.3112 4.77178L4.65357 5.73001L3.87888 6.85598C3.80141 6.96921 3.65852 6.96712 3.58277 6.85179L2.83046 5.70485L2.19004 4.72775C2.19004 4.72775 1.58062 3.62274 2.38113 3.64161C3.0973 3.65839 3.33487 4.23291 3.37619 4.35452L3.7532 4.36081L4.14744 4.3671C4.19564 4.22871 4.43493 3.65419 5.13904 3.63952C5.87414 3.61855 5.42655 4.53904 5.34563 4.6963Z",
		fill: "currentColor"
	})
});
export default SvgLolCreep;
